import type { KeyboardEvent } from 'react';

import { cx } from '@hrworks/design-system/functions';
import { useResponsiveProp } from '@hrworks/sui-shared/hooks';

import { useResolveImageSrc } from '../Image';
import { S } from './Logo.styles';
import type { LogoProps } from './Logo.types';

export const Logo = ({
  alt,
  className,
  href,
  onClick,
  ref,
  src: srcFromProps,
  target,
  title,
  ...otherProps
}: LogoProps) => {
  const responsiveSource = useResponsiveProp(srcFromProps);
  const { src } = useResolveImageSrc(responsiveSource ?? '');

  return (
    <S.LogoContainer ref={ref} className={cx(S.cls.LogoContainer, className)} {...otherProps}>
      <S.LogoLink
        className={S.cls.LogoLink}
        href={href}
        target={target}
        onClick={onClick}
        {...(onClick &&
          !href && {
            tabIndex: 0,
            role: 'button',
            onKeyDown: (e: KeyboardEvent<HTMLAnchorElement>) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.currentTarget.click();
              }
            },
          })}
        {...(!onClick && !href && { role: 'presentation' })}
      >
        {srcFromProps && <S.Logo className={S.cls.Logo} alt={alt} src={src} />}
        {title && (
          <S.Title className={S.cls.Title} overflowBehaviour="ellipsis" component="div">
            {title}
          </S.Title>
        )}
      </S.LogoLink>
    </S.LogoContainer>
  );
};
